import { LoadingButton } from '@mui/lab';
import { Box, styled } from '@mui/material';

// export const GradientBorderWrapper = styled(Box)({
//   fontWeight: 700,
//   backgroundColor: 'transparent',
//   background:
//     'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(56,56,56,1) 35%, rgba(56,56,56,1) 65%, rgba(0,0,0,1) 100%)',
//   color: 'white',
//   border: '2px solid transparent',
//   backgroundClip: 'padding-box',
//   position: 'relative',
//   '&:before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     right: 0,
//     left: 0,
//     bottom: 0,
//     zIndex: -1,
//     margin: '-2px',
//     borderRadius: 'inherit',
//     background:
//       'linear-gradient(90deg, rgba(196,150,59,1) 0%, rgba(221,198,116,1) 25%, rgba(221,198,116,1) 45%, rgba(191,149,59,1) 100%)',
//   },
// });

export const ThemeButton = styled(LoadingButton)(({ theme }) => ({
  flex: 1,
  height: '36px',
  minHeight: '36px',
  borderRadius: '25px',
  background: theme.palette.gradients.buttonPrimary,
  color: '#fff !important',
  fontWeight: 700,
  fontSize: '16px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    background: theme.palette.gradients.buttonPrimary,
    filter: 'brightness(0.95)',
  },
  '&:disabled': {
    background: '#E5E7EB',
    color: '#a0a1a3 !important',
  },
}));

export const ThemeButtonOutlined = styled(LoadingButton)(({ theme }) => ({
  flex: 1,
  height: '36px',
  minHeight: '36px',
  borderRadius: '25px',
  border: `2px solid ${theme.palette.primary.main}`,
  color: `${theme.palette.primary.main}`,
  fontWeight: 700,
  fontSize: '16px',
  textTransform: 'none',
  boxShadow: 'none',
}));

export const GradientBorderWrapper = ({ children, wrapperProps = {}, sx = {}, ...others }) => (
  <Box
    {...wrapperProps}
    sx={{
      padding: '2px',
      border: '1px solid gold',
      borderRadius: 1,
      background: 'linear-gradient(0deg, #C4C4C4 0%, #FCFCFC 51.95%, #D2D2D2 100%)',
      boxShadow: '0px 2px 6px 0px #000000B2',
      ...(wrapperProps?.sx || {}),
    }}
  >
    <Box
      sx={{
        borderRadius: 'inherit',
        ...sx,
      }}
      {...others}
    >
      {children}
    </Box>
  </Box>
);

export const GoldBorderButton = ({ children, sx = {}, wrapperSx = {}, wrapperProps = {}, ...others }) => (
  <Box
    sx={{
      borderRadius: '6px',
      border: 'none',
      ...wrapperSx,
    }}
    {...wrapperProps}
  >
    <LoadingButton
      sx={{
        fontWeight: 500,
        backgroundColor: 'primary.light',
        color: '#000',
        borderRadius: 'inherit',
        ':hover': {
          backgroundColor: 'primary.light',
        },
        ...sx,
      }}
      {...others}
    >
      {children}
    </LoadingButton>
  </Box>
);

export const ShiningGoldBorder = styled('div')(() => ({
  height: 'fit-content',
  position: 'relative',
  padding: 2,
  flex: 1,
  borderRadius: '8px',
  background: `linear-gradient(90deg, #BC8001 0%, #C8941C 17.62%, #FAEB9A 26.88%, #C8941C 32.84%, #C8941C 38.5%, #FAEB9A 43.4%, #FAEB9A 52.96%, #C8941C 59.75%, #C8941C 63.11%, #FAEB9A 72.02%, #C8941C 79.16%, #BC8001 100%)`,
}));
